import { api as wiredApi } from './index';

/**
 * A rider's delivery company on InGo's API (InGo ADR 0032; Rio, 2 Oct 2026:
 * "we can rebuild that too to make it smoother for them"). The owner opens it,
 * adds new riders, who choose their own passwords from an emailed link, and
 * takes them out; a rider leaves from their profile. The owner's figures are
 * read from the commission lines on the server, never worked out here; the
 * old screen took 15 % off in the browser.
 *
 * Built from its client so a test can hand it a fake; `fleetApi` is the
 * wired copy.
 */
export function createFleetApi({ api }) {
  return {
    /**
     * `GET rider/me/fleet?period=today|week|month`: `role` is `owner` (the
     * whole fleet: each rider, their live delivery in full, the period's
     * figures), `rider` (which fleet, and whose) or null (none).
     */
    async me(period = 'week') {
      const { data } = await api.get('/rider/me/fleet', { query: { period } });

      return data;
    },

    /** `POST rider/me/fleet`: the rider opens their company, as its owner. */
    async open(name, tradingName = null) {
      const { data, message } = await api.post('/rider/me/fleet', { name, trading_name: tradingName || null });

      return { ...data, message };
    },

    /**
     * `POST rider/me/fleet/riders`: a new rider, by the owner. No password:
     * the rider chooses theirs from the link the server emails them.
     */
    async addRider(details) {
      const { data, message } = await api.post('/rider/me/fleet/riders', details);

      return { ...data, message };
    },

    /** `DELETE rider/me/fleet/riders/{id}`: out of the fleet, still a rider. */
    async takeOut(riderId) {
      const { message } = await api.delete(`/rider/me/fleet/riders/${encodeURIComponent(riderId)}`);

      return message;
    },

    /** `POST rider/me/fleet/leave`: the rider leaves; they stay a rider. */
    async leave() {
      const { message } = await api.post('/rider/me/fleet/leave', {});

      return message;
    },
  };
}

export const fleetApi = createFleetApi({ api: wiredApi });
